import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cloneDeep, merge } from "lodash";
import { proposalKeyMaker } from "../hooks/useGetProposal";
import { proposalsKeyMaker } from "../hooks/useGetProposals";
import { proposalsUrl, } from "../requests/getProposals";
import patchProposal from "../requests/patchProposal";
export default function usePatchProposal(queryParams, config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ proposalId, request }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return patchProposal(proposalId, request, config);
        },
        onMutate: async ({ proposalId, request }) => {
            await queryClient.cancelQueries({
                queryKey: [proposalsUrl()],
                exact: false,
            });
            // NOTE: optimistic update on the proposal list level
            queryClient.setQueryData(proposalsKeyMaker(queryParams), (query) => {
                if (query) {
                    return {
                        ...query,
                        values: query.values.map((proposal) => proposal.proposalId === proposalId
                            ? merge(cloneDeep(proposal), {
                                status: {
                                    internal: request.internalProposalStatus,
                                },
                            })
                            : proposal),
                    };
                }
            });
            // NOTE: optimistic update on the proposal details level
            queryClient.setQueryData(proposalKeyMaker(proposalId), (query) => {
                if (query) {
                    return {
                        ...query,
                        proposalDetails: merge(cloneDeep(query.proposalDetails), {
                            proposal: {
                                status: {
                                    internal: request.internalProposalStatus,
                                },
                            },
                        }),
                    };
                }
            });
            return { proposalId, request };
        },
        onSuccess: (_, { proposalId }) => {
            // NOTE: invalidate all cached and paginated proposal queries
            queryClient.invalidateQueries({ queryKey: [proposalsUrl()] });
            // NOTE: invalidate modified proposal
            queryClient.invalidateQueries({
                queryKey: proposalKeyMaker(proposalId),
            });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=usePatchProposal.js.map